import { map, switchMap, take } from 'rxjs/operators';
/**
 * Retrieves the Profile for the current session
 * @public
 * @param session - The session manager
 * @returns Profile object
 */
export function getUserProfileV1(session) {
    return session.sessionAndBindings.pipe(switchMap(s => session.httpClient.get('ProfileServices', `/v1/users/${s.UdsSession.PrismGuid}`)));
}
/**
 * Updates the Session's Profile language
 * @public
 * @param session - The session manager
 * @param language - Language code that will be used to update the profile
 */
export async function updateProfileLanguage(session, language) {
    return session.sessionAndBindings
        .pipe(switchMap(s => session.httpClient.put('ProfileServices', `/v1/users/${s.UdsSession.PrismGuid}/language`, {
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ language }),
    })), take(1), map(() => undefined))
        .toPromise();
}
